// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 10803-停车场新增 POST /web/v1/parking/add */
export async function addParking(
  body: API.ParkingAddReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOLong>("/web/v1/parking/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10805-停车场删除 GET /web/v1/parking/delete/${param0} */
export async function deleteParking(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteParkingParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/parking/delete/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 10802-停车场详情查询 GET /web/v1/parking/detail/${param0} */
export async function getParkingDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getParkingDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimGymParkingDetailVo>(
    `/web/v1/parking/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 10801-停车场列表查询 GET /web/v1/parking/list */
export async function getParkingList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getParkingListParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimGymParkingListVo>(
    "/web/v1/parking/list",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 10804-停车场修改 POST /web/v1/parking/update */
export async function updateParking(
  body: API.ParkingUpdateReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/parking/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10807-停车场车位更新 POST /web/v1/parking/updateSpace */
export async function updateParkingSpace(
  body: API.ParkingSpaceUpdateReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/parking/updateSpace", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10806-停车场状态变更 POST /web/v1/parking/updateStatus */
export async function updateParkingStatus(
  body: API.ParkingStatusUpdateReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/parking/updateStatus", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
